import { createFileRoute } from "@tanstack/react-router";
import { ConnectFinish } from "@/features/integrations/ConnectFinish";

export const Route = createFileRoute("/connect/finish")({
  validateSearch: (search: Record<string, unknown>) => ({
    provider: typeof search.provider === "string" ? search.provider : "",
    handle: typeof search.handle === "string" ? search.handle : "",
  }),
  component: ConnectFinishRoute,
});

function ConnectFinishRoute() {
  const { provider, handle } = Route.useSearch();
  return <ConnectFinish key={handle} provider={provider} handle={handle} />;
}
